"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Td = exports.Th = exports.Tr = exports.TFoot = exports.THead = exports.TBody = exports.Table = exports.TableTitle = exports.TableContainer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
require("./Table.css");
var TableContainer = function (_a) {
  var className = _a.className,
    children = _a.children,
    restProps = __rest(_a, ["className", "children"]);
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-table-container", className)
  }, {
    children: children
  }));
};
exports.TableContainer = TableContainer;
var TableTitle = function (_a) {
  var className = _a.className,
    children = _a.children,
    restProps = __rest(_a, ["className", "children"]);
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-table-title", className)
  }, {
    children: children
  }));
};
exports.TableTitle = TableTitle;
var Table = function (_a) {
  var className = _a.className,
    children = _a.children,
    restProps = __rest(_a, ["className", "children"]);
  return (0, jsx_runtime_1.jsx)("table", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-table", className)
  }, {
    children: children
  }));
};
exports.Table = Table;
var TBody = function (_a) {
  var className = _a.className,
    children = _a.children,
    restProps = __rest(_a, ["className", "children"]);
  return (0, jsx_runtime_1.jsx)("tbody", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-tbody", className)
  }, {
    children: children
  }));
};
exports.TBody = TBody;
var THead = function (_a) {
  var className = _a.className,
    children = _a.children,
    restProps = __rest(_a, ["className", "children"]);
  return (0, jsx_runtime_1.jsx)("thead", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-thead", className)
  }, {
    children: children
  }));
};
exports.THead = THead;
var TFoot = function (_a) {
  var className = _a.className,
    children = _a.children,
    restProps = __rest(_a, ["className", "children"]);
  return (0, jsx_runtime_1.jsx)("tfoot", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-tfoot", className)
  }, {
    children: children
  }));
};
exports.TFoot = TFoot;
var Tr = function (_a) {
  var className = _a.className,
    children = _a.children,
    restProps = __rest(_a, ["className", "children"]);
  return (0, jsx_runtime_1.jsx)("tr", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-table-row", className)
  }, {
    children: children
  }));
};
exports.Tr = Tr;
var buildCellClasses = function (center, className, nowrap, right) {
  return (0, classnames_1.default)("vsx-cell", className, {
    "vsx-cell-right": right
  }, {
    "vsx-cell-center": center
  }, {
    "vsx-cell-nowrap": nowrap
  });
};
var Th = function (_a) {
  var center = _a.center,
    className = _a.className,
    nowrap = _a.nowrap,
    right = _a.right,
    children = _a.children,
    restProps = __rest(_a, ["center", "className", "nowrap", "right", "children"]);
  return (0, jsx_runtime_1.jsx)("th", __assign({}, restProps, {
    className: "".concat(buildCellClasses(center, className, nowrap, right), " vsx-table-header")
  }, {
    children: children
  }));
};
exports.Th = Th;
var Td = function (_a) {
  var center = _a.center,
    className = _a.className,
    nowrap = _a.nowrap,
    right = _a.right,
    children = _a.children,
    restProps = __rest(_a, ["center", "className", "nowrap", "right", "children"]);
  return (0, jsx_runtime_1.jsx)("td", __assign({}, restProps, {
    className: buildCellClasses(center, className, nowrap, right)
  }, {
    children: children
  }));
};
exports.Td = Td;